"use client"
import React, { useState } from "react";
import styles from "./SideBar.module.css";
import languageCode from "@/DB/LanguageCodeDB.json";
import i18n from "i18next";
import { accordion, OnOpenUrl } from "./accordion";
import { useTranslation } from "react-i18next";
import Image from "next/image";
import downBtn from "@/assets/Icon/Down_Icon.png";
import languageImage from "@/assets/Icon/Global_Icon.png";
import local from "@/DB/LanguageDB.json";
import { useRouter } from 'next/navigation'; 
const languageKey = Object.keys(local);

const SideBar = ({onPanelOpen, isPanelOpen}) => {
    const options = languageCode.map((value, index) => ({
        value: languageKey[index],
        label: value
    }));
    
        const router = useRouter();
    const {t} = useTranslation();
    const [selected, setSelected] = useState(i18n.language);
    const [isLanguageOpen, setIsLanguageOpen] = useState(false);
    const [openIndex, setOpenIndex] = useState(null);
    const toggleMenu = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };
    const handleLanguageOpen = (isOpen) => {
        setIsLanguageOpen(isOpen);
    }
    const changeLanguage = (lang) => {
        setIsLanguageOpen(false);
        i18n.changeLanguage(lang);
    };
    
    i18n.on("languageChanged", (lng) => {
        setSelected(lng);
    });
    return (
        <div className={`${styles.dimmed} ${isPanelOpen ? styles.open : ""}`} onClick={() => {
            if(isPanelOpen) {
                onPanelOpen(false)
            }
        }}>
            <div className={`${styles["side-bar"]} ${isPanelOpen ? styles.open : ""}`}  onClick={(e) => e.stopPropagation()}>
                <div className={styles["side-bar__top"]}>
                    <div className={styles["side-bar__language"]}onClick={() => handleLanguageOpen(!isLanguageOpen)}>

                        {options.map((option, index) => (
                            <ul key={index} onClick={() => changeLanguage(option.value)} className={`${styles.active__language} ${selected === option.value ? "" : styles.hidden} 
                            ${!isLanguageOpen && selected !== option.value ? styles.open : ""}`}>
                                <li className={styles.no_dot}>{option.label}</li>
                            </ul>
                        ))}

                        <Image src={languageImage} className={styles.language__image} alt="language icon"></Image >
                    </div>

                    

                </div>
                <div className={styles["side-bar__accordion"]}>
                    {accordion.map((item, index) => (
                        <nav key={index} className={`${styles.accordion__container} ${openIndex === index ? styles.open : ""}`}>
                            <span className={`${styles["side-bar__accordion__content"]} `} onClick={() => toggleMenu(index)}>
                                {t(item.nameKey)}
                                <div className={styles.accordion__toggle}>
                                    <Image src={downBtn} className={`${styles.accordion__toggle__image} ${openIndex === index ? styles.open : ""}`} alt="accordion toggle"></Image >
                                </div>
                            </span>

                            {
                                item.content.map((content, key) => (
                                    <ul key={key} className={`${styles.accordion__depth2} ${openIndex === index ? styles.open : ""}`} onClick={() => { OnOpenUrl({content : content, navigate: router}) }}>
                                       <li className={styles.no_dot}> {t(content.nameKey)}</li>
                                    </ul>
                                ))
                            }
                        </nav>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default SideBar;